import * as React from 'react';

import { renderEmpty } from '../../common/Render';
import { sortByKeyComparator } from '../../util/ArrayUtil';

import { IReportSettings, PM } from '../../../../interfaces';

import ISettings from './ISettings';
import IWidgetProps from './IWidgetProps';
import SoftwareTable from './SoftwareTable';


interface IProps extends IWidgetProps {
    settings: ISettings;
}

interface ISoftwareById {
    nodeId?: PM.ISoftware[];
}

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        systems: React.PropTypes.array.isRequired,
        software: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderData(nodes: PM.ISystem[], softwareById: ISoftwareById, settings: ISettings, reportSettings: IReportSettings) {
        const byParent = nodes.reduce((map, node) => {
            const parentId = node._searchIdx.parentNames.slice(2).join(' / ');

            if (!map[parentId]) {
                map[parentId] = [];
            }

            map[parentId].push(node);

            return map;
        }, {});

        const parents = Object.keys(byParent).sort();

        return parents.map(function (parent) {
            const parentKey = `parent-${parent}`;

            const children = byParent[parent].map((node) => {
                const nodeKey = `node-${node.id}`;
                const software = softwareById[node.id].sort(sortByKeyComparator('date', -1));

                return (
                    <div key={nodeKey}>
                        <SoftwareTable title={node.name} software={software} settings={settings} />
                    </div>
                );
            });

            return (
                <div key={parentKey} className="space-xl">
                    <h4>{parent}</h4>
                    {children}
                </div>
            );
        });
    }

    render() {
        let { systems, software } = this.props;
        const { settings, reportSettings } = this.props;

        systems = systems.filter((system: PM.ISystem) => {
            if (!system.pmInformation) {
                return false;
            }

            if (!settings.displaySystemsWithoutSoftware) {
                const systemSoftware = software[system.id] || [];
                return systemSoftware.length > 0;
            }

            return true;
        });

        let renderedData;
        if (systems && systems.length) {
            renderedData = this.renderData(systems, software, settings, reportSettings);
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/pm/listSoftware/Widget.tsx